export default "__VITE_ASSET__DkNf68Ne__"